import React, { useState } from 'react'
import { Button, Dialog } from '@material-ui/core'
import BarChartIcon from '@material-ui/icons/BarChart'
import TablaCamionesCalados from '../../../Camiones/containers/listados/camionesCalados/containers/TablaCamionesCalados'
import BarChart from '../../../Calado/components/BarChart'
import DialogView from '../../../Dialogos/DialogView'
import { COLORES } from '../../../../config/colores'

export default function EstadoPlayaCamionesCalados (props) {
  const { data, calificacionCalles, camionesCalados, dialogOpen = null } = props
  const [open, setOpen] = useState(false)
  const [openListado, setOpenListado] = useState(false)

  const handleClose = () => {
    setOpen(false)
    if (dialogOpen) { dialogOpen(true) }
  }

  const handleOpen = () => {
    setOpen(true)
    if (dialogOpen) { dialogOpen(true) }
  }

  const handleOpenListado = () => {
    setOpenListado(true)
    if (dialogOpen) { dialogOpen(true) }
  }

  const handleCloseListado = () => {
    setOpenListado(false)
    if (dialogOpen) { dialogOpen(false) }
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='lg'
      >
        <DialogView
          cancelCallback={handleClose}
          title='Estado calles de calado'
          content={
            <>
              {(data.length > 0) && (calificacionCalles) && (camionesCalados) &&
              <BarChart
                width={1000}
                height={450}
                data={data}
                calificacionCalles={calificacionCalles}
                camionesCalados={camionesCalados}
                xRange={[0, 970]}
                yRange={[350, 0]}
                setCalleDeCalado={() => {}}
              />
              }
              {(data.length === 0) && <div className='loader' /> }
            </>
          }
        />
      </Dialog>

      <Dialog
        open={openListado}
        onClose={handleCloseListado}
        maxWidth='lg'
      >
        <DialogView
          cancelCallback={handleCloseListado}
          title='Listado de camiones calados'
          content={<TablaCamionesCalados />}
        />
      </Dialog>

      <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap' }}>
        <Button
          size='small'
          className='btn-reportes-bruto'
          onClick={handleOpenListado}
          variant='contained'
          style={{
            color: '#ffffff',
            backgroundColor: COLORES.grey.dark,
            borderRadius: '22px',
            margin: '2px',
            width: '75%'
          }}
        >
                Ver listado
        </Button>

        <Button
          size='small'
          className='btn-reportes-bruto'
          variant='contained'
          style={{
            color: '#ffffff',
            backgroundColor: COLORES.grey.dark,
            borderRadius: '22px',
            margin: '2px',
            width: '20%'
          }}
          onClick={handleOpen}
        >
          <BarChartIcon style={{ color: '#ffffff' }} />
        </Button>
      </div>

    </>
  )
}
